(function () {
    'use strict';

    angular
        .module('app.clubAdmin')
        .component('sc3Favorites', {
            templateUrl: 'app/club-admin/favorites/favorites.component.html',
            controller: FavoritesComponent,
            bindings: {
                players: '<'
            }
        });

    var noop = angular.noop;

    FavoritesComponent.$inject = ['toggleFriend'];
    function FavoritesComponent(toggleFriend) {
        var ctrl = this;
        ctrl.removeFriend = removeFriend;

        ///////////////////////////////////////////////

        function removeFriend(friend) {
            friend.isFriend = true;
            toggleFriend(friend, true).then(success, noop);
            function success() {
                ctrl.players.remove(friend);
            }
        }
    }
})();

